<template>
    <a v-if="isExternalLink" :href="to" :target="target" @click="navTools.hideMobileNav">
        <slot></slot>
    </a>
    <NuxtLink v-else :to="to" :target="target" @click.native="navTools.hideMobileNav">
        <slot></slot>
    </NuxtLink>
</template>

<script setup>
    const navTools = useNavTools();

    const props = defineProps({
        to: {
            required: true,
            default: '#',
            type: String
        },
        target: {
            default: null,
            type: String
        }
    });

    //console.log(props.to);

    const isExternalLink = computed(() => /^https?:\/\//.test(props.to));
</script>

